import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import {from, lastValueFrom, Observable} from 'rxjs';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth.service';

export const refreshInterceptor: HttpInterceptorFn = (httpRequest: HttpRequest<unknown>, httpHandlerFn: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (httpRequest.url.startsWith('https://${backend}') && !httpRequest.url.endsWith('/api/rest/web/v2/app2/auth/refresh')) {
    const authService: AuthService = inject(AuthService);

    const intercept: () => Promise<HttpEvent<unknown>> = async (): Promise<HttpEvent<unknown>> => {
      let response: HttpEvent<unknown>;

      try {
        response = await lastValueFrom(httpHandlerFn(httpRequest));
      } catch (err: any) {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          try {
            await authService.refresh();
            const accessToken: string = authService.accessToken;

            if (accessToken) {
              httpRequest = httpRequest.clone({
                setHeaders: {
                  Authorization: `Bearer ${accessToken}`
                }
              });
            }
          } catch (err: any) {
            await authService.logout();
            throw err;
          }

          response = await lastValueFrom(httpHandlerFn(httpRequest));
        } else {
          throw err;
        }
      }

      return response;
    }

    return from(intercept());
  }

  return httpHandlerFn(httpRequest);
}
